import React, { useEffect } from 'react';
import VideoClauseErrorMessage from './VideoClauseErrorMessage/VideoClauseErrorMessage';
import { VideoIncompatibilityErrorMessage } from './VideoIncompatibilityErrorMessage/VideoIncompatibilityErrorMessage';
import { CREDIT_CARD } from 'constants/userProfile';
import { checkUserInvestmentTypeAndReturnActiveOne } from 'utilities/userProfile';
import { connect } from 'react-redux';
import { doTaggingVideoErrorMessage } from '../tagging';

const VideoErrorMessages = ({ investmentType, isInvalidBrowser, userProfileForm }) => {
    const userInvestmentType = checkUserInvestmentTypeAndReturnActiveOne(investmentType);
    const isVideoClauseValueInvalid = !userProfileForm?.agreeVideoCallClauseCheck?.valid;
    const showVideoClauseErrorMessage = !isInvalidBrowser && isVideoClauseValueInvalid;

    useEffect(() => {
        showVideoClauseErrorMessage && doTaggingVideoErrorMessage();
    }, [showVideoClauseErrorMessage]);

    return (
        <>
            {isInvalidBrowser && (
                <VideoIncompatibilityErrorMessage isCreditCardInvestmentType={userInvestmentType[CREDIT_CARD]} />
            )}
            {showVideoClauseErrorMessage && <VideoClauseErrorMessage />}
        </>
    );
};
export default connect(state => ({
    userProfileForm: state.userProfileForm,
}))(VideoErrorMessages);
